import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LazyAnimation from './LazyAnimation';
import QuotationIcon from '../images/icon_quotations_alt2.svg';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: '#F7F7F7',
    paddingTop: 117,
    paddingBottom: 117,
    position: 'relative',
  },
  divider: {
    position: 'absolute',
    width: '100%',
    backgroundImage:
      'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0xMjgwIDE0MFYwSDBsMTI4MCAxNDB6Ii8+PC9nPjwvc3ZnPg==)',
    backgroundSize: '100% 100px',
    top: 0,
    height: 100,
    transform: 'rotateY(180deg)',
  },
  container: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
  },
  header: {
    fontFamily: 'PoppinsSemiBold',
    fontWeight: '600',
    fontSize: 30,
    lineHeight: '1.5em',
    paddingBottom: 15,
    color: '#333333',
    textAlign: 'center',
  },
  quoteDividerWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  quoteContainer: {
    display: 'flex',
    padding: 30,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  quote: {
    fontFamily: 'MontserratMedium',
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 1.5,
    color: '#666666',
    paddingBottom: '1em',
  },
  author: {
    fontFamily: 'MontserratBold',
    fontSize: 15,
    fontWeight: '700',
    lineHeight: 1.5,
    color: '#666666',
    marginTop: 32,
  },
  title: {
    fontFamily: 'MontserratMedium',
    fontSize: 13,
    fontWeight: '500',
    lineHeight: 1.5,
    color: '#666666',
  },
  imageWrapper: {
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: '0 auto 20px',
    },
  },
  image: {
    width: 90,
    height: 90,
    borderRadius: 45,
    objectFit: 'cover',
  },
}));

function QuoteSection() {
  const classes = useStyles();

  return (
    <section id="quote-section">
      <div className={classes.wrapper}>
        <div className={classes.divider} />
        <div className={classes.container}>
          <LazyAnimation type="translate-bottom-20">
            <Typography className={classes.header}>
              What Clients are Saying
            </Typography>
          </LazyAnimation>
          <div className={classes.quoteDividerWrapper}>
            <img src={QuotationIcon} alt="" title="" />
          </div>
          <div className={classes.quoteContainer}>
            <div className={classes.imageWrapper}>
              <img
                className={classes.image}
                src="https://solutions.crediblemind.com/wp-content/uploads/2019/12/norris-tyler.png"
                alt=""
                title=""
              />
            </div>
            <div className={classes.quoteWrapper}>
              <Typography className={classes.quote}>
                This is a one-of-a-kind offering, driven by data scientists and
                academic experts that is helping ensure individuals seeking help
                on the web are getting credible, trustworthy resources.
              </Typography>
              <Typography className={classes.author}>
                Tyler Norris, MDiv
              </Typography>
              <Typography className={classes.title}>
                Chief Executive, WELL BEING TRUST
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuoteSection;
